import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EntityContextMenuItem {
  label: string;
  icon: string;
  action: string;
}

export interface EntityContextMenuData {
  entityId: string;
  entityType: string;
  entityTitle: string;
  actions: EntityContextMenuItem[];
}

@Component({
  selector: 'app-entity-context-menu-dialog',
  templateUrl: './entity-context-menu-dialog.component.html',
  styleUrls: ['./entity-context-menu-dialog.component.css']
})
export class EntityContextMenuDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EntityContextMenuData,
    public dialogRef: MatDialogRef<EntityContextMenuDialogComponent>
  ) {}

  onActionClick(action: string): void {
    this.dialogRef.close(action);
  }
}

